var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import { COST_CHART_TYPE } from '../../constants/data.constant';
import { costTypes } from '../../actions/types/cost.types';

export default ((state = initialState, action) => {
    switch (action.type) {

        case costTypes.SET_COST_TYPE:
            return reduceCostType(state, action);

        case costTypes.SET_COST_DATE:
            return reduceCostDate(state, action);

        default:
            return state;
    }
});

const reduceCostType = (state, action) => {
    const { type } = action.payload;
    return _extends({}, state, {
        type
    });
};

const reduceCostDate = (state, action) => {
    const { date } = action.payload;
    return _extends({}, state, {
        date
    });
};

export const initialState = {
    date: null,
    type: COST_CHART_TYPE.DAY
};


// WEBPACK FOOTER //
// ./~/pluton-core/lib/reducers/core/cost.reducer.js